export enum AuthorizedState {
    Authorized = 'Authorized',
    Unauthorized = 'Unauthorized',
    Unknown = 'Unknown',
}
